import {availableTranslations} from './translations-config'

type RequestInitWithTimeout = RequestInit & {timeout?: number}

interface TranslationRequest {
  from: string
  to: string
  type: string
  id: string
}

export function isLanguageSupported(language: string): boolean {
  return !!availableTranslations[language]
}

export async function translate(data: TranslationRequest, timeout = 10000) {
  const body = new FormData()

  for (const [key, value] of Object.entries(data)) {
    body.append(key, value)
  }

  const response = await fetchWithTimeout('/localization/translations', {
    timeout,
    method: 'POST',
    body,
    mode: 'same-origin',
    headers: new Headers({
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'GitHub-Verified-Fetch': 'true',
    }),
  })

  return response.json()
}

export async function triggerLanguageDetection(url: string): Promise<void> {
  validateLanguageDetectionUrl(url)

  await fetchWithTimeout(url, {
    method: 'POST',
    headers: new Headers({'GitHub-Verified-Fetch': 'true'}),
    timeout: 5000,
  })
}

async function fetchWithTimeout(resource: RequestInfo, options: RequestInitWithTimeout) {
  const {timeout} = options

  const controller = new AbortController()
  const id = setTimeout(() => controller.abort(), timeout)

  const response = await fetch(resource, {
    ...options,
    signal: controller.signal,
  })
  clearTimeout(id)

  return response
}

export function validateLanguageDetectionUrl(url: string): void {
  const parsedUrl = new URL(url, window.location.origin)

  if (parsedUrl.origin !== window.location.origin) {
    throw new Error(`Language detection URL "${parsedUrl}" must be relative`)
  }

  // The URL path must match the pattern of valid discussion or discussion comment language detection URLs
  // Valid discussion language detection URL: /OWNER/REPO/discussions/ID/language_detections
  // Valid discussion comment language detection URL: /OWNER/REPO/discussions/ID/comments/ID/language_detections
  if (!/^\/[\w-]+\/[\w.-]+\/discussions\/\d+(\/comments\/\d+)?\/language_detections$/.test(parsedUrl.pathname)) {
    throw new Error(
      `Language detection URL path "${parsedUrl.pathname}" must match /OWNER/REPO/discussions/ID/language_detections or /OWNER/REPO/discussions/ID/comments/ID/language_detections`,
    )
  }
}
